<div class="card full-card shadow-sm m-4 card-v-center">
  <div class="card-body">
    <!-- <div>
    <img class="img" src="/assets/images/rdp/Richiesta_assistenza_OK.svg" alt="imgHelpDeskOk" width="140"
      height="140" />
    <div class="text col-md-10">
      <h3>
        <b>Complimenti, la sua richiesta di assistenza è stata inviata con
        successo.</b>
      </h3>
      <p class="pb-4">
        Per visualizzare la richiesta di assistenza appena creata la invitiamo
        a selezionare il button "Richieste di Assistenza".
      </p>

      <p class="ps-4 pe-4">
        Le ricordiamo che potrà gestire i vari scambi di comunicazione con il team Help Desk direttamente dalla sua
        casella email. <br>
        Nel caso avesse bisogno di ulteriori chiarimenti, la invitiamo a consultare la sezione dedicata alle FAQ
        disponibile in Piattaforma Italia.
      </p>

      <p class="ps-4 pe-4" [innerHTML]=" 'generic.best-regards' | translate">
      </p>

      <hr class="line">
      <div class="d-flex justify-content-between align-items-center">
        <button class="not btn btn-primary btn-rounded" (click)="goToHome()">
          <span class="ms-3" style="align-self: center; font-size: 0.8rem; font-weight: 500">
            <b translate>actions.homepage</b>
          </span>
        </button>

        <button class="btn btn-primary btn-rounded" (click)="goToHelpDeskList()">
          <span style="align-self: center; font-size: 0.8rem; font-weight: 500">
            <b translate>help-desk.rda</b>
          </span>
        </button>
      </div>
    </div>
  </div>
  <hr /> -->

  <h3 class="ps-4 pb-4"><b translate>help-desk.success-request.line-1</b></h3>

  <p class="ps-4" translate>help-desk.success-request.line-2</p>

  <p class="ps-4 pe-4" translate>help-desk.success-request.line-3</p>

  @if (!directChannel) {
    <p class="ps-4 pe-4" [innerHTML]="'help-desk.success-request.line-4-bank' | translate"></p>
  }
  @if (directChannel) {
    <p class="ps-4 pe-4" [innerHTML]="'help-desk.success-request.line-4-pi' | translate" ></p>
  }

  <p class="ps-4 pe-4" [innerHTML]=" 'help-desk.success-request.line-5' | translate">
  </p>


  <hr class="line" />
  <div class="d-flex justify-content-between align-items-center">
    <button class="not btn btn-primary btn-rounded" (click)="goToHome()">
      <span class="ms-3" style="align-self: center; font-size: 0.8rem; font-weight: 500">
        <b translate>actions.homepage</b>
      </span>
    </button>

    <button class="btn btn-primary btn-rounded" (click)="goToHelpDeskList()">
      <span class="px-2">
        <b translate>help-desk.rda</b>
      </span>
    </button>
  </div>
</div>
</div>
